export const PRE_REGISTRATION_TOKEN_SUPERSEDED = "PRE_REGISTRATION_TOKEN_SUPERSEDED";

export const isSupersededValidationResponse = (data: any): boolean =>
  data?.reason === "SUPERSEDED" ||
  data?.errorCode === PRE_REGISTRATION_TOKEN_SUPERSEDED;

export const isSupersededSearch = (search: string): boolean =>
  new URLSearchParams(search || "").get("reason") === "superseded";

export const supersededSearchParam = "?reason=superseded";
